import { render, staticRenderFns } from "./RectangleIcon.vue?vue&type=template&id=5507cab4"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5507cab4')) {
      api.createRecord('5507cab4', component.options)
    } else {
      api.reload('5507cab4', component.options)
    }
    module.hot.accept("./RectangleIcon.vue?vue&type=template&id=5507cab4", function () {
      api.rerender('5507cab4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/libs/lightbox/RectangleIcon.vue"
export default component.exports